import React from "react";

export default function Footer() {
  return (
    <footer className="text-center mt-5">
      <p>&copy; 2026 James White. All rights reserved.</p>
    </footer>
  );
}